/* TECHNOW — Subtle smoke reference. Presentation only; Impulse owns submission. */
(() => {
  if (window.TechnowNeonButton) { window.TechnowNeonButton.scan(document); return; }
  const selector = '[data-technow-neon], .qsc2-stickybar__action-btn';
  const instances = new Map();
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  let frame = 0;
  let last = -Infinity;
  let observer;
  const origin = performance.now();

  // Smoke renderer. Runs inside a Web Worker (OffscreenCanvas) when supported so the
  // per-pixel noise never blocks the main thread; the same code is the fallback below.
  function smokeKernel(scope) {
    const lattice = new Float32Array(65536);
    let seed = 78123;
    for (let i = 0; i < lattice.length; i++) {
      seed = (Math.imul(seed, 1664525) + 1013904223) >>> 0;
      lattice[i] = seed / 4294967295;
    }
    const clamp = value => Math.max(0, Math.min(1, value));
    function noise(x, y) {
      const ix = Math.floor(x), iy = Math.floor(y), fx = x - ix, fy = y - iy;
      const sx = fx * fx * (3 - 2 * fx), sy = fy * fy * (3 - 2 * fy);
      const a = lattice[((iy & 255) << 8) | (ix & 255)];
      const b = lattice[((iy & 255) << 8) | ((ix + 1) & 255)];
      const c = lattice[(((iy + 1) & 255) << 8) | (ix & 255)];
      const d = lattice[(((iy + 1) & 255) << 8) | ((ix + 1) & 255)];
      return (a + (b - a) * sx) * (1 - sy) + (c + (d - c) * sx) * sy;
    }
    function fbm(x, y) {
      let sum = 0, weight = .56;
      for (let k = 0; k < 4; k++) {
        sum += noise(x, y) * weight;
        x = x * 2.03 + 13.1; y = y * 2.03 + 7.3; weight *= .48;
      }
      return sum / .9784;
    }
    function draw(context, image, t) {
      const w = image.width, h = image.height, pixels = image.data;
      for (let y = 0; y < h; y++) for (let x = 0; x < w; x++) {
        const u = x / w, v = y / h;
        const qx = fbm(u * 2.8 - t * .11, v * 1.6 + t * .045);
        const qy = fbm(u * 2.8 + 31 + t * .06, v * 1.6 + 11);
        const detail = fbm(u * 4.6 - t * .19 + qx * 1.4, v * 2.2 + qy * .6);
        const density = clamp((detail - .26) * 1.8) * (.56 + .44 * Math.sin(v * Math.PI));
        const bright = clamp(density), offset = (y * w + x) * 4;
        pixels[offset] = Math.round(185 + bright * 49);
        pixels[offset + 1] = Math.round(2 + bright * 15);
        pixels[offset + 2] = Math.round(28 + bright * 17);
        pixels[offset + 3] = Math.round(clamp(density * (.72 + .28 * Math.sin(v * Math.PI))) * 160);
      }
      context.putImageData(image, 0, 0);
    }
    if (scope) {
      const surfaces = new Map();
      scope.onmessage = event => {
        const data = event.data;
        if (data.type === 'init') {
          surfaces.set(data.id, { canvas: data.canvas, context: data.canvas.getContext('2d'), image: null });
          return;
        }
        const surface = surfaces.get(data.id);
        if (!surface) return;
        if (data.type === 'size') {
          surface.canvas.width = data.w; surface.canvas.height = data.h;
          surface.image = surface.context.createImageData(data.w, data.h);
        } else if (data.type === 'paint') {
          if (surface.image) draw(surface.context, surface.image, data.t);
          scope.postMessage(data.id);
        } else if (data.type === 'run') {
          // The worker owns the ~30fps animation clock, so the page keeps no rAF loop alive.
          surface.running = data.on;
          if (data.on) origin = data.origin;
          if (data.on && !timer) timer = setTimeout(loop, 0);
        }
      };
      let timer = 0, origin = 0;
      const loop = () => {
        timer = 0;
        let any = false;
        const t = (performance.timeOrigin + performance.now() - origin) / 1000 * .55;
        surfaces.forEach(surface => {
          if (!surface.running) return;
          any = true;
          if (surface.image) draw(surface.context, surface.image, t);
        });
        if (any) timer = setTimeout(loop, 33);
      };
    }
    return draw;
  }
  const remotes = new Map();
  let draw = null, worker = null, workerFailed = false, nextId = 0;
  function getWorker() {
    if (worker || workerFailed) return worker;
    try {
      if (typeof OffscreenCanvas === 'undefined' || !HTMLCanvasElement.prototype.transferControlToOffscreen) throw 0;
      const url = URL.createObjectURL(new Blob(['(' + smokeKernel + ')(self);'], { type: 'text/javascript' }));
      worker = new Worker(url);
      worker.onmessage = event => { const m = remotes.get(event.data); if (m) m.busy = false; };
    } catch (_) { workerFailed = true; worker = null; }
    return worker;
  }
  function available(button) {
    return !button.disabled && button.getAttribute('aria-disabled') !== 'true'
      && !button.classList.contains('btn--loading');
  }
  function paint(m, t) {
    if (!m.pixels || !m.visible || document.hidden) return;
    if (m.remote) {
      if (m.busy) return;
      m.busy = true;
      m.remote.postMessage({ type: 'paint', id: m.id, t });
      m.dirty = false;
      return;
    }
    draw = draw || smokeKernel(null);
    draw(m.context, m.pixels, t);
    m.dirty = false;
  }
  function moving(m) {
    return m.visible && m.button.isConnected && available(m.button) && !document.hidden && !reduced.matches;
  }
  function tick(now) {
    frame = 0;
    let active = false;
    for (const m of instances.values()) {
      if (!m.button.isConnected) { dispose(m); continue; }
      if (!m.remote && moving(m)) {
        active = true;
        if (now - last >= 33) paint(m, (now - origin) / 1000 * .55);
      }
    }
    if (now - last >= 33) last = now;
    if (active) frame = requestAnimationFrame(tick);
  }
  function sync() {
    let active = false;
    for (const m of instances.values()) {
      if (!m.button.isConnected) { dispose(m); continue; }
      const run = moving(m);
      m.button.toggleAttribute('data-neon-moving', run);
      if (m.remote) {
        if (m.running !== run) {
          m.running = run;
          m.remote.postMessage({ type: 'run', id: m.id, on: run, origin: performance.timeOrigin + origin });
        }
        if (m.dirty && !run) paint(m, reduced.matches ? 3.5 : (performance.now() - origin) / 1000 * .55);
        continue;
      }
      if (m.dirty) paint(m, reduced.matches ? 3.5 : (performance.now() - origin) / 1000 * .55);
      active = active || run;
    }
    if (!active && frame) { cancelAnimationFrame(frame); frame = 0; }
    if (active && !frame) frame = requestAnimationFrame(tick);
  }
  function repair(m) {
    if (m.button.classList.contains('btn--loading')) return;
    // Some cart apps replace innerHTML. Restore presentation on the original button.
    if (!m.button.contains(m.content)) {
      const message = m.button.textContent.trim();
      const label = m.content.querySelector('[data-add-to-cart-text]');
      if ([label.dataset.defaultText, window.theme?.strings?.soldOut, window.theme?.strings?.unavailable].includes(message)) {
        label.textContent = message;
      }
      for (const node of [...m.button.childNodes]) if (node.nodeType === 3) node.remove();
      m.button.append(m.content);
    }
    for (const node of m.decorations) if (!m.button.contains(node)) m.button.prepend(node);
    if (m.spinner && !m.button.contains(m.spinner)) m.button.append(m.spinner);
  }
  function dispose(m) {
    m.resizeObserver?.disconnect();
    m.stateObserver.disconnect();
    m.intersectionObserver?.disconnect();
    m.productContainer?.removeEventListener('variantChange', m.onVariant);
    m.button.removeAttribute('data-neon-moving');
    m.pixels = null;
    // A canvas handed to the worker can no longer be resized here; the worker keeps it.
    if (!m.remote) m.canvas.width = 0;
    else { remotes.delete(m.id); m.remote.postMessage({ type: 'run', id: m.id, on: false, origin: 0 }); }
    instances.delete(m.button);
  }
  function init(button) {
    if (instances.has(button)) return;
    // The sticky app owns its labels and submission. Add decoration without moving its nodes.
    const sticky = button.matches('.qsc2-stickybar__action-btn');
    if (sticky) {
      button.setAttribute('data-technow-neon', '');
      for (const name of ['haze', 'smoke', 'tube', 'travel']) {
        if (button.querySelector('.technow-neon-' + name)) continue;
        const node = document.createElement(name === 'smoke' ? 'canvas' : 'span');
        node.className = 'technow-neon-' + name;
        node.setAttribute('aria-hidden', 'true');
        button.prepend(node);
      }
    }
    const content = sticky ? button : button.querySelector('.technow-neon-content');
    const canvas = button.querySelector('.technow-neon-smoke');
    if (!content || !canvas) return;
    let context = null, remote = null, id = canvas.dataset.neonSurface;
    if (id) remote = getWorker(); // canvas already transferred (e.g. bfcache restore)
    else if (getWorker()) {
      try {
        const offscreen = canvas.transferControlToOffscreen();
        id = String(++nextId);
        worker.postMessage({ type: 'init', id, canvas: offscreen }, [offscreen]);
        canvas.dataset.neonSurface = id;
        remote = worker;
      } catch (_) { remote = null; }
    }
    if (!remote) {
      if (canvas.dataset.neonSurface) return;
      context = canvas.getContext('2d');
      if (!context) return;
    }
    const m = { button, content, canvas, context, remote, id, busy: false, size: '', visible: false, dirty: true, pixels: null,
      decorations: [...button.querySelectorAll('.technow-neon-haze, .technow-neon-smoke, .technow-neon-tube, .technow-neon-travel')],
      spinner: button.querySelector('.loading__spinner') };
    instances.set(button, m);
    if (remote) remotes.set(id, m);
    const resize = () => {
      const width = button.clientWidth;
      if (width < 1) return;
      const pixelsWidth = Math.max(128, Math.round(width * .65));
      if (remote) {
        if (m.size !== pixelsWidth + 'x36' || !m.pixels) {
          remote.postMessage({ type: 'size', id, w: pixelsWidth, h: 36 });
          m.size = pixelsWidth + 'x36'; m.pixels = true; m.dirty = true;
        }
      } else if (canvas.width !== pixelsWidth || canvas.height !== 36 || !m.pixels) {
        canvas.width = pixelsWidth; canvas.height = 36;
        m.pixels = context.createImageData(pixelsWidth, 36); m.dirty = true;
      }
      sync();
    };
    m.resizeObserver = new ResizeObserver(resize);
    m.resizeObserver.observe(button);
    m.stateObserver = new MutationObserver(() => { repair(m); sync(); });
    m.stateObserver.observe(button, { childList: true, subtree: true, attributes: true,
      attributeFilter: ['disabled', 'aria-disabled', 'class'] });
    if ('IntersectionObserver' in window) {
      m.intersectionObserver = new IntersectionObserver(entries => {
        m.visible = entries[0].isIntersecting; sync();
      });
      m.intersectionObserver.observe(button);
    } else m.visible = true;
    m.productContainer = button.closest('[data-product-handle]');
    m.onVariant = event => {
      const prices = m.content.querySelector('[data-technow-neon-prices]');
      if (!prices) return;
      const variant = event.detail?.variant;
      prices.hidden = !variant?.available;
      if (!variant) return;
      const sale = variant.compare_at_price > variant.price;
      prices.querySelector('.technow-neon-promo').hidden = !sale;
      const compare = prices.querySelector('.technow-neon-compare');
      compare.hidden = !sale;
      const format = cents => window.theme.Currency.formatMoney(cents, window.theme.settings.moneyFormat);
      if (sale) compare.innerHTML = format(variant.compare_at_price);
      prices.querySelector('.technow-neon-price').innerHTML = format(variant.price);
    };
    m.productContainer?.addEventListener('variantChange', m.onVariant);
    resize();
  }
  function scan(scope) {
    if (scope.matches?.(selector)) init(scope);
    scope.querySelectorAll(selector).forEach(init);
    sync();
  }
  function start() {
    scan(document);
    observer?.disconnect();
    observer = new MutationObserver(records => {
      for (const record of records) for (const node of record.addedNodes) {
        if (node.nodeType === 1 && (node.matches(selector) || node.querySelector(selector))) scan(node);
      }
      for (const m of instances.values()) if (!m.button.isConnected) dispose(m);
      sync();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
  window.TechnowNeonButton = { scan };
  reduced.addEventListener('change', () => { for (const m of instances.values()) m.dirty = true; sync(); });
  document.addEventListener('visibilitychange', sync);
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload', event => {
    for (const m of instances.values()) if (event.target.contains(m.button)) dispose(m);
    sync();
  });
  window.addEventListener('pagehide', () => {
    observer?.disconnect();
    for (const m of instances.values()) dispose(m);
    if (frame) cancelAnimationFrame(frame);
    frame = 0;
  });
  window.addEventListener('pageshow', event => { if (event.persisted) start(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
